const roles = [
  {
    icon: 'ri-star-line',
    title: 'Первое впечатление',
    desc: 'Руководитель создаёт первое впечатление о компании. Встретить лично, рассказать о целях отдела, объяснить, почему выбрали именно этого кандидата. Первый разговор задаёт тон всему испытательному сроку.',
  },
  {
    icon: 'ri-task-line',
    title: 'Постановка задач',
    desc: 'Чёткие, измеримые задачи на первую неделю, месяц и испытательный срок. Без этого новичок не понимает, куда двигаться. Задачи должны быть амбициозными, но достижимыми — не «посмотрим», а конкретный план.',
  },
  {
    icon: 'ri-chat-smile-2-line',
    title: 'Регулярная обратная связь',
    desc: 'Ежедневно в первую неделю, еженедельно в первый месяц. Не формальная «как дела», а конкретный фидбэк: что получилось, что усилить, какие следующие шаги. Обратная связь — главный инструмент руководителя в адаптации.',
  },
  {
    icon: 'ri-rocket-2-line',
    title: 'Мотивация',
    desc: 'Отмечать маленькие победы, поддерживать при неудачах. Создавать атмосферу, где ошибка — это опыт, а не повод для наказания. Мотивированный сотрудник выходит на KPI в 2 раза быстрее.',
  },
  {
    icon: 'ri-arrow-up-circle-line',
    title: 'Развитие',
    desc: 'Уже на испытательном сроке обсуждать перспективы роста. Сотрудник должен видеть, куда он может вырасти в компании. План развития на год — логичное завершение адаптации.',
  },
  {
    icon: 'ri-radar-line',
    title: 'Контроль',
    desc: 'Не микроменеджмент, а разумный контроль. Чек-листы, контрольные точки, KPI испытательного срока. Контроль даёт руководителю данные для принятия решения, а сотруднику — ориентиры.',
  },
];

export default function ManagerRole() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Роль руководителя в адаптации сотрудников
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Руководитель — главный человек в онбординге. Ни HR, ни наставник не заменят прямого руководителя. Вот шесть зон ответственности, которые определяют успех адаптации.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {roles.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 border border-gray-100 hover:border-teal-300 transition-all group">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}